import React from 'react';
import { Icon, Dropdown, Checkbox } from 'semantic-ui-react';
import LoadingComponent from '../../common/LoadingComponent';

export class TableAddColumn extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    dropdownClicked = () => {
        if (this.props.headerClickHideResourcePane) {
            this.props.headerClickHideResourcePane()
        }
    }
    handleCheckboxClick = (e, item) => {
        this.setState({ loading: true });
        this.props.handleTableComponent(e, item, this.props.item);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultMarkAll !== this.props.defaultMarkAll) {
            this.setState({ loading: false });
        }
    }
    render() {

        let itemKey = this.props.item.key && typeof (this.props.item.key) === 'object' ? this.props.item.key[0] : this.props.item.key

        return (
            <div className="float-left " style={{
                width: itemKey === "action" ? "100%" : "calc(100% - 20px)",
                textOverflow: "ellipsis"
            }}>

                <React.Fragment>
                {this.state.loading  ? ( 
                    <LoadingComponent active={true} message="Selecting all data..." />
                ) : null}
                    {this.props.item.sortable ?
                        itemKey === this.props.column ?
                            <Icon
                                name={`arrow ${this.props.direction}`} />
                            : <Icon
                                className="opacity-2"
                                name="sort" /> : null
                    }
                    {this.props.item.name === "Checkbox" ?
                        <Checkbox
                            //defaultChecked={this.props.defaultMarkAll ? this.props.defaultMarkAll : false}
                            checked={this.props.defaultMarkAll ? this.props.defaultMarkAll : false }
                            onChange={this.handleCheckboxClick}
                        />
                        :
                        this.props.item.name}
                    {itemKey === "action" ?
                        <Dropdown
                            text={this.props.actionType === "List Action" ? "Actions" : null}
                            icon={this.props.actionType === "List Action" ? 'caret down' : 'ellipsis vertical'}
                            direction="left"
                            onClick={this.dropdownClicked}>
                            <Dropdown.Menu>
                                <Dropdown.Item icon='filter' text='Advance Filter' onClick={this.props.showFilterHeader}/> 
                                {this.props.csvData ?
                                    <Dropdown.Item
                                        icon='file excel outline'
                                        text='Download as CSV'
                                        onClick={this.props.downloadAsCSV} /> : null}
                                {/* Reset Filter only shown when actionType is List Action */}
                                 {/* {this.props.item.actionType && (  */}
                                    <Dropdown.Item icon='undo' text='Reset Filter' onClick={this.props.resetFilter} />
                                {/* )} */}
                                {this.props.item.actionType ?
                                    <Dropdown.Item
                                        icon={this.props.actionType === "List Action" ? 'ellipsis vertical' : "ellipsis horizontal"}
                                        text={this.props.actionType === "List Action" ? 'Grid Action' : "List Action"}
                                        onClick={this.props.changeMenuView} />
                                    : null
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                        : null}
                </React.Fragment>
            </div>
        )
    }
}

